import type { OrganizationDto } from '@_/api-contracts/public-api.ts';
import { createFileRoute } from '@tanstack/react-router';
import { isApiError } from '@_/utils-frontend';
import { publicApiClient } from '#src/api.ts';
import { OnboardCompletePage } from '#src/pages/OnboardingPage/index.ts';

export const Route = createFileRoute('/{-$locale}/onboarding/_wrapper/complete')({
  component: RouteComponent,
  loaderDeps: ({ search }) => ({ organizationId: search.organizationId }),
  loader: async ({ deps }) => {
    const { organizationId } = deps;

    let organization: OrganizationDto | undefined;
    if (organizationId) {
      try {
        const resp = await publicApiClient.organizations.get({
          params: { id: organizationId }
        });
        organization = resp.data;
      } catch (error) {
        if (!isApiError(error) || error.status !== 404) {
          throw error;
        }
      }
    }

    return {
      organization
    };
  }
});

function RouteComponent() {
  const { organization } = Route.useLoaderData();
  return <OnboardCompletePage organization={organization} />;
}
